import { Decorator } from 'final-form'
import createDecorator from 'final-form-calculate'
import { OrderItemClient } from 'schema'

export const companyTypeDecorator = [
  createDecorator({
    field: 'type',
    updates: (value) => {
      if (value) {
        return {
          company: undefined
        }
      }

      return {}
    }
  }) as Decorator<{ company: any; contact: any; type: Values<typeof OrderItemClient.type> }>
]
